import { observer } from "mobx-react";
import { Menu } from "primereact/menu";
import React from "react";
import styled from "styled-components";
import { withWSErrorContainer } from "../../error/withWSErrorContainer";

import { MenuItem } from "primereact/menuitem";
import { concatClassnames } from "../../utils/util";

export interface CvpMenuProps extends MenuItem {
  model: MenuItem[];
  popup?: boolean;
  className?: string;
  id?: string;
}

export const CvpMenu: React.FC<CvpMenuProps> = withWSErrorContainer(
  observer(({ model, className, ...otherProps }) => {
    return (
      <StyledCvpMenu
        className={`cvp-nav-menu ${concatClassnames([className])}`}
        model={model}
        pt={{ action: { ["aria-hidden"]: "false" } }}
        {...otherProps}
      />
    );
  })
);

const StyledCvpMenu = styled(Menu)`
  &.cvp-nav-menu {
    border: none;

    .p-focus > .p-menuitem-content {
      background: var(--primary-100);
    }

    .p-menuitem-link {
      .p-menuitem-text {
        color: var(--text-color);
      }

      &:hover:not(:disabled) {
        background-color: var(--primary-100);
        transition: all ease-out 0.2s;
      }

      &:focus {
        box-shadow: none;
      }
    }

    .p-menuitem-icon {
      color: var(--text-color);
    }

    .active.active.active.active.active {
      background-color: var(--primary-100);

      .p-menuitem-link.p-menuitem-link.p-menuitem-link {
        transition: none;
      }

      .p-menuitem-text,
      .p-menuitem-icon {
        color: var(--primary-700);
      }

      &:hover:not(:disabled) {
        .p-menuitem-text {
          font-weight: 500;
          transition: all ease-out 0.3s;
        }
      }
    }
  }
`;
